<template>
  <div class="header">
    <div class="header-left">
      <router-link to="/">
        <div id="logoDiv" :class="collapsed ? 'logo logo2' : 'logo'"></div>
      </router-link>
      <div class="toggleIcon" @click="$emit('toggleCollapse')">
        <img v-if="collapsed" src="../assets/img/retract2.png" />
        <img v-else src="../assets/img/retract.png" />
      </div>
      <Breadcrumb>
        <BreadcrumbItem
          v-for="(item, index) in breadcrumbs"
          :key="index"
          :to="item.path"
          >{{ item.title }}
        </BreadcrumbItem>
      </Breadcrumb>
    </div>

    <div class="right">
      <Tooltip
        class="item"
        content="在线客服"
        max-width="200"
        v-if="$store.state.userInfo.type == 20"
      >
        <Icon class="servicePng" @click="onPushToIM" />
        <t-badge
          dot
          count="99"
          :offset="[9, -30]"
          v-if="$store.state.im.showNoticeBadge"
        >
        </t-badge>
      </Tooltip>
      <!-- <Tooltip class="item" content="使用协议" max-width="200">
        <Icon class="contractPng" />
      </Tooltip>
      <Tooltip class="item" content="帮助中心" max-width="200">
        <Icon class="helpPng" />
      </Tooltip> -->
      <!-- <div class="line"></div> -->
      <template>
        <div class="user-info" @click="open()">
          <Icon class="peoplePng" />
          <div class="text" @click="openModel = true">
            <!-- {{ userInfo.company && userInfo.company + '-'
                }}{{ userInfo.identity }}-{{ userInfo.realName }} -->
            <div>{{ userInfo.realName }}</div>
            <div>{{ userInfo.identity }}</div>
          </div>
          <i
            class="ivu-icon ivu-menu-submenu-title-icon"
            :class="addClass()"
          ></i>
        </div>
        <transition name="fade-dropdown">
          <div v-if="show" class="msgDiv" @mouseleave="close()">
            <div class="userInfo">
              <Icon class="headPng" />
              <div>
                <div class="user-name">{{ userInfo.realName }}</div>
                <div class="user-identity">
                  <div class="roleName">{{ userInfo.identity }}</div>
                  <t-divider layout="vertical" />
                  <div class="company">
                    {{
                      userInfo.isSupplierSubordinate &&
                      userInfo.supplierSubordinateName
                        ? userInfo.supplierSubordinateName
                        : userInfo.company || '蜜雪冰城'
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="user-opera">
              <Button @click="$router.push('/my-setting')" class="butSty"
                >修改密码</Button
              >
              <div class="show-tabMenu">
                <div>显示标签栏</div>
                <t-switch :value="tabMenu" @change="(val) => (tabMenu = val)" />
              </div>
            </div>
            <div class="logout">
              <Button @click="logout" class="butSty">退出登录</Button>
            </div>
          </div>
        </transition>
      </template>

      <!-- <span class="item" title="设置" @click="$router.push('/my-setting')">
        <Icon type="md-settings" :size="20" color="#000" />
      </span>  -->
      <!-- <span class="item" title="登出" @click="logout">
        <Icon type="md-exit" :size="20" color="#000" />
      </span> -->
    </div>
    <audio
      id="messageAudio"
      :src="require('@/assets/message.mp3')"
      type="audio/mpeg"
    ></audio>
  </div>
</template>
<script>
import logoutHandler from '../assets/js/logoutHandler'
export default {
  name: 'MXHeader',
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    breadcrumbs() {
      const currentPath = this.$route.path
      const menus = this.$store.state.menus || []
      const crumbs = []

      // Helper function to find a path in the menu tree
      const findInMenus = (path) => {
        for (const category of menus) {
          if (category.children) {
            const child = category.children.find((item) => {
              const target = item.target.startsWith('/')
                ? item.target
                : '/' + item.target
              // Handle optional query params in target if any
              return target.split('?')[0] === path
            })
            if (child) {
              const target = child.target.startsWith('/')
                ? child.target
                : '/' + child.target
              return [
                { title: category.name, path: '' }, // Parent level usually not clickable
                { title: child.name, path: target },
              ]
            }
          }
        }
        return null
      }

      // 1. Try to find the current path directly in menus
      let foundCrumbs = findInMenus(currentPath)

      if (foundCrumbs) {
        crumbs.push(...foundCrumbs)
      } else {
        // 2. If not found, check if it's an inner page with a parentPath
        const parentPath = this.$route.meta && this.$route.meta.parentPath
        if (parentPath) {
          const parentCrumbs = findInMenus(parentPath)
          if (parentCrumbs) {
            crumbs.push(...parentCrumbs)
          }
          // Add the current page title
          if (this.$route.meta.title) {
            crumbs.push({ title: this.$route.meta.title, path: currentPath })
          }
        } else {
          // 3. Fallback to matched routes if no menu match or parentPath
          return this.$route.matched
            .filter((item) => item.meta && item.meta.title)
            .map((item) => ({
              title: item.meta.title,
              path: item.path,
            }))
        }
      }

      return crumbs
    },
    userInfo() {
      return JSON.parse(localStorage.userInfo)
    },
    tabMenu: {
      get() {
        return this.$store.state.tabMenu
      },
      set(value) {
        this.$store.commit('setTabMenu', value)
      },
    },
  },
  mounted() {},
  methods: {
    logout() {
      this.$Modal.confirm({
        title: '注意',
        content: '您确定要退出系统吗？',
        okText: '退出',
        onOk: () => {
          // if (this.$wser) this.$wser.close()
          this.$axios.delete('/logout').then(() => {
            logoutHandler()
          })
        },
      })
    },
    open() {
      if (this.show == true) {
        this.show = false
      } else {
        this.show = true
      }
    },
    close() {
      this.show = false
    },
    addClass() {
      if (this.show == true) {
        return 'ivu-icon-ios-arrow-up'
      } else {
        return 'ivu-icon-ios-arrow-down'
      }
    },
    onPushToIM() {
      if (this.$store.state.userInfo.type == 20) {
        this.$store.commit('setImNoticeBadgeState', false)
        this.$router.push('/im')
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.header
  position relative
  z-index 99
  display flex
  height 56px
  justify-content space-between
  align-items center
  background #fff
  padding 0 10px
  padding-right 20px
  border-bottom 1px solid #F3F3F3
  .header-left
    display: flex
    align-items: center
    height: 100%
  .logo
    height 34px
    width: 129px
    margin-left: 8px
    margin-right: 95px
    margin-top 2px
    background url('../assets/img/newLogo.png') no-repeat
    background-size 129px
    transition-duration: 0.4s
    transition-property:width
  .logo2
    width: 34px
    margin-right: 24px
  .toggleIcon
    width: 28px
    height: 28px
    cursor: pointer
    margin-right: 16px
    display: flex
    align-items: center
    justify-content: center
    img
      width: 18px
      height: 18px
  .right
    display flex
    justify-content flex-end
    align-items center
   .user-info
      height: 44px
      font-size: 16px
      padding: 0 8px
      color: #000
      display: flex
      align-items: center
      cursor: pointer
      .text
          margin: 0 6px;
          font-family: AlibabaPuHuiTi, sans-serif;
          div:nth-child(1)
            font-size: 14px;
          div:nth-child(2)
            font-size: 12px;
            color: #8c8c8c;
      .peoplePng
        border-radius: 50%
        width: 32px
        height: 32px
        background: url('../views/home/assets/person.png') no-repeat center
        background-size: 32px
    .user-info:hover
      border-radius 5px
      background #eee
    .msgDiv
      position: fixed
      width: 320px
      height: 206px
      top: 56px
      border-radius: 6px
      overflow: hidden
      background: #fff
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15)
      font-family: AlibabaPuHuiTi, sans-serif
      .userInfo
        height: 72px
        border-bottom: 1px solid rgba(240, 240, 240, 1)
        display: flex
        align-items: center
        padding: 0 16px
      .headPng
        border-radius: 6px
        width: 40px
        height: 40px
        margin-right: 8px
        background: url('../views/home/assets/person.png') no-repeat center
        background-size: 40px
      .user-name
        font-size: 16px
        color: #101010
      .user-identity
        display: flex
        align-items: center
        font-size: 12px
        color: #8c8c8c
        .roleName
          white-space: nowrap
        .company
          width: 135px
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
      .user-opera
        padding: 6px
        border-bottom: 1px solid rgba(240, 240, 240, 1)
      .show-tabMenu
        height: 36px
        display: flex
        align-items: center
        justify-content: space-between
        padding: 0 12px
      .logout
        padding: 6px
      .butSty
        height: 36px
        width: 100%
        border: none
        font-size: 14px
        text-align: left
        padding-left: 12px
        &:hover
          border-radius 4px
          background #f3f3f3

    .item
      cursor pointer
      transition all .2s
      line-height 1
      margin-left 17px
      .helpPng
        height 30px
        width 30px
        background url('../assets/img/help.png') no-repeat
        background-size 22px
        background-position 4px 5px
      .contractPng
        height 30px
        width 30px
        background url('../assets/img/contract.png') no-repeat
        background-size 22px
        background-position 5px 5px
      .servicePng
        height 30px
        width 30px
        background url('../assets/img/service.png') no-repeat
        background-size 22px
        background-position 5px 5px
      &:hover
        border-radius 5px
        background #eee
.line
  width: 1px;
  height: 22px;
  background: #dcdcdc;
  margin-left: 16px;
  margin-right: 12px;

.fade-dropdown-enter-active,
.fade-dropdown-leave-active
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)

.fade-dropdown-enter,
.fade-dropdown-leave-to
  opacity: 0
  transform: translateY(-10px)
</style>
